import { Navigate } from 'react-router-dom';

import { useAuth } from '@alamo/auth';

interface ConsultorOnlyRouteProps {
  children: React.ReactNode;
}

/**
 * Gate for routes that belong exclusively to CONSULTANTS (any type).
 *
 * What these routes actually require is a `consultant_profile`: their
 * endpoints are scoped by it, so anyone without one lands on an empty or 403
 * screen. Gating on the profile — instead of on a list of role names — keeps
 * any newly created profile behaving correctly without touching this file.
 *
 * CLT passes through: hierarchy is type-free (decisão 2026-07-09) — an
 * internal consultant can lead a team and refer people below them.
 */
export function ConsultorOnlyRoute({ children }: ConsultorOnlyRouteProps) {
  const { consultantType } = useAuth();

  if (consultantType == null) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
